/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.leaflet-panel[_ngcontent-%COMP%]{margin:5px;height:60vh}div.result-container[_ngcontent-%COMP%]{padding:5px}\n/*# sourceMappingURL=search-result-tabs.component.css.map*/"];
export { styles as styles };
